module.exports = __webpack_public_path__ + "img/index-solution-02.35a62cca.jpg";